import { ApiConstants, OverlaysConstants } from '../constants/actions';

export const getLoginAction = (
  username,
  password,
  {
    isAutoLogin = false,
    autoRedirect = true,
    rememberMe = false
  }: {
    isAutoLogin?: boolean;
    autoRedirect?: boolean;
    rememberMe?: boolean;
  } = {}
) => ({
  type: `${ApiConstants.LOGIN_ACTION}_REQUEST`,
  payload: { username, password, rememberMe },
  isAutoLogin,
  autoRedirect
});

export const getImpersonationLoginAction = payload => ({
  type: `${ApiConstants.LOGIN_ACTION}_SUCCESS`,
  payload
});

export const showLoginPopup = form => ({
  type: OverlaysConstants.SHOW_LOGIN_POPUP,
  form
});

export const loginPopupAction = actionType => ({
  type: `${OverlaysConstants.LOGIN_POPUP_ACTION}`,
  actionType
});

export const getLogoutAction = (sessionExpired = false) => ({
  type: `${ApiConstants.LOGOUT_ACTION}_REQUEST`,
  sessionExpired: !!sessionExpired
});
